export default __webpack_public_path__ + "static/MONAPEPE-9141756317b1763b5113b9103ea9753a.jpg";